module.exports = __webpack_public_path__ + "img/negocioAhora.b45a85e5.svg";